import React from 'react';

const HomeHero = () => {

  const pageHandler =()=>{
    window.location.href = "/classes";
  }
  return (
    <section className="home-hero-section">
      <div className="home-hero-outer">
        <div className="home-hero-inner">
          <p className="home-hero-info">Find Your Energy</p>
          <h1 className="home-hero-heading">MAKE YOUR BODY <br /> FIT & PERFECT</h1>
          <button className="home-hero-button" onClick={pageHandler}>Our Classes </button>
        </div>
      </div>
    </section>
  )
}

export default HomeHero;